import { render, staticRenderFns } from "./render-attachment-modal.vue?vue&type=template&id=32c609fe&scoped=true&"
import script from "./render-attachment-modal.vue?vue&type=script&lang=js&"
export * from "./render-attachment-modal.vue?vue&type=script&lang=js&"
import style0 from "./render-attachment-modal.vue?vue&type=style&index=0&id=32c609fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c609fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
